import { render } from "./BaseApparel.vue?vue&type=template&id=0018c10b&scoped=true"
const script = {}

import "./BaseApparel.vue?vue&type=style&index=0&id=0018c10b&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0018c10b"]])

export default __exports__